module.exports = __webpack_public_path__ + "static/media/event-08.c7ad3cbc.jpg";